<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ActivesTypeForm v-if="activestype" :activesType="activestype" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ActivesTypeForm from '@/components/settings/stock-registers/activesType/ActivesTypeForm.vue'

  export default {
    name: 'ActivesType',
    components: {
      PageTitle,
      PageRowWrapper,
      ActivesTypeForm
    },
    computed: {
      ...mapState({
        activestype: state => state.activestype.activesTypeById
      })
    },
    methods: {
      ...mapActions('activestype', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
